module.exports = __webpack_public_path__ + "static/images/collapsed.3xC8DZd.svg";